import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import type { CalendarComposePopoutConfig, FullComposeViewState } from 'owa-calendar-compose-types';
import { AddPopoutSource, addPopoutV2 } from 'owa-popout-v2';
import { closeComposeForm } from 'owa-calendar-compose-form-actions';
import type { FullComposeEntrySourceType } from 'owa-calendar-helpers-types/lib/ComposeMetricTypes';
import { FluidOwaSource, isFluidEnabledForSource } from 'owa-fluid-validations';
import addTab from 'owa-tab-store/lib/utils/addTab';
import { TabType } from 'owa-tab-store';
import { isFeatureEnabled } from 'owa-feature-flags';
import type { CreateCollabSpaceOnInitProps } from 'owa-calendar-helpers-types';

const CALENDAR_POPOUT_WINDOW_SIZE = {
    width: 1095,
    height: 640,
};

export default function popoutCalendarCompose(
    event: Partial<CalendarEvent>,
    entrySource: FullComposeEntrySourceType,
    originalEvent?: Partial<CalendarEvent>,
    viewState?: FullComposeViewState,
    source?: AddPopoutSource,
    createCollabSpaceOnInitProps?: CreateCollabSpaceOnInitProps
) {
    const tabId = isFeatureEnabled('cal-fullcompose-popout-projection')
        ? addTab(
              TabType.CalendarCompose,
              false /* isShown */,
              false /* makeActive */,
              'composeId0' // To do VSO: [WI# 111936 to pass in the unique composeIds once we have multi-store composeViewstates]
          )
        : undefined;

    addPopoutV2('calendar', 'compose', {
        deeplinkData: () => {
            let popoutViewState: CalendarComposePopoutConfig = {
                viewState,
                event: event as CalendarEvent,
                originalEvent: originalEvent as CalendarEvent,
                composeEntrySource: entrySource,
                includeFluidOnPopout: isFluidEnabledForSource(FluidOwaSource.CalendarCompose),
                createCollabSpaceOnInitProps,
            };
            closeComposeForm(false /* shouldResetComposeStoreForUndo */, event.IsMeeting);
            return Promise.resolve(popoutViewState);
        },
        projectionTabId: tabId,
        CALENDAR_POPOUT_WINDOW_SIZE,
    });
}
